/** X brand glyph (lucide v1 dropped brand icons). Inherits currentColor. */
export function IgGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M18.9 2H22l-6.8 7.8L23.2 22h-6.3L12 14.6 5.5 22H2.4l7.2-8.4L1.6 2h6.5l4.5 6.7L18.9 2Zm-1.1 18h1.7L7.2 3.9H5.4L17.8 20Z" fill="currentColor" />
    </svg>
  );
}

/** Puzzle-piece-free "extension" glyph: a browser window with a plug dot. */
export function ExtensionGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M2.5 8.5h19" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="5.6" cy="6.25" r=".9" fill="currentColor" />
      <circle cx="8.4" cy="6.25" r=".9" fill="currentColor" />
      <path d="M9 14.5h6M12 11.5v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
